module.exports = __webpack_public_path__ + "img/1484475214.a7f48389.jpg";